const errorCodes = require("../assets/json/error-codes.json");

export const sweetAlert2 = {
    methods: {
        swalAlert(text = "Notify staff to process payment.", title = "Online payment error") {
            this.$swal({
                title: title,
                text: text,
                allowOutsideClick: false
            });
        },
        swalAlertHtml(html, title = "Online payment error") {
            this.$swal({
                title: title,
                html: html,
                allowOutsideClick: false
            });
        },
        swalError(errorCode) {
            const err = errorCodes.find(e => e.errorCode === errorCode);
            this.$swal({
                title: err.title,
                text: err.text,
                allowOutsideClick: false
            });
        },
        swalConfirm(action, text = "Notify staff to process payment.", title = "Online payment error", confirmButtonText = "OK", cancelButtonText = "Cancel") {
            this.$swal({
                    title: title,
                    text: text,
                    confirmButtonText: confirmButtonText,
                    cancelButtonText: cancelButtonText,
                    showCancelButton: true,
                    allowOutsideClick: false
                })
                .then(
                    result => {
                        if (result && result.isConfirmed && action) {
                            action();
                        }
                    });
        },
        swalToast(text) {
            this.$swal({
                position: "top-end",
                title: text,
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true
            });
        }
    }
}